export default __webpack_public_path__ + "static/media/hand-holding-using-credit-card-payment-online-shopping-pink-background-3d-rendering.f3a2a72b.jpg";